var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnomalySelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8819 13.8335H21.739C20.8982 17.9163 17.3049 20.9846 12.9996 20.9846C8.69441 20.9846 5.10113 17.9163 4.26034 13.8335H3.11743C3.97428 18.5353 8.06751 22.1066 12.9996 22.1066C17.9318 22.1066 22.025 18.5353 22.8819 13.8335ZM22.8817 10.1669H21.7388C20.8978 6.08449 17.3046 3.01648 12.9996 3.01648C8.69465 3.01648 5.10153 6.08449 4.26048 10.1669H3.11756C3.97468 5.46544 8.06774 1.89453 12.9996 1.89453C17.9315 1.89453 22.0246 5.46544 22.8817 10.1669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8512 13.8335C20.0199 17.392 16.8216 20.0449 12.9998 20.0449C9.17794 20.0449 5.9796 17.392 5.14832 13.8335H3.99976C4.85066 18.0176 8.55676 21.1668 12.9998 21.1668C17.4428 21.1668 21.1488 18.0176 21.9998 13.8335H20.8512ZM5.14832 10.1668C5.9796 6.60835 9.17794 3.95545 12.9998 3.95545C16.8216 3.95545 20.0199 6.60835 20.8512 10.1668H21.9998C21.1488 5.98272 17.4428 2.8335 12.9998 2.8335C8.55676 2.8335 4.85066 5.98272 3.99976 10.1668H5.14832Z",
    fill: "#DCE0E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.873529,
    y: 0.77258,
    width: 24.2522,
    height: 24.6998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.12195
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.12195
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnomalySelected);
export default __webpack_public_path__ + "static/media/anomaly-selected.9e474fdc07d0d596d7ca8e70701a6af5.svg";
export { ForwardRef as ReactComponent };